// extracted by mini-css-extract-plugin
export var container = "_4x-0";
export var infoButton = "_4x-1";
export var label = "_4x-3";
export var labelExpanded = "_4x-4";
export var price = "_4x-5";
export var priceExpanded = "_4x-6";
export var title = "_4x-2";